import { useMemo, ReactNode } from 'react';

type TranslateFn = (
    key: string,
    defaultMessage?: string,
    options?: any
) => string;

interface UsePageTitleProps {
    id?: string;
    t: TranslateFn;
}

/**
 * Custom hook for generating a formatted page title with ID
 *
 * @param id - The application ID from URL params
 * @param t - Translation function
 * @returns Formatted title with smaller ID text, or plain text title if no ID
 */
export const usePageTitle = ({ id, t }: UsePageTitleProps): ReactNode => {
    return useMemo(() => {
        if (id) {
            return (
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-start',
                        gap: 8,
                    }}
                >
                    <span>
                        {t(
                            'preliminary-applications.titles.working_with_the_application'
                        )}
                    </span>

                    <span
                        style={{
                            fontSize: '0.45em',
                            opacity: 0.7,
                            padding: '5px 0',
                        }}
                    >
                        {id}
                    </span>
                </div>
            );
        }

        return t(
            'preliminary-applications.titles.working_with_the_application'
        );
    }, [id, t]);
};
